import { DirectionProvider } from '@radix-ui/react-direction';
import type { ReactNode } from 'react';

/**
 * Root of every app (T4 §6.1): Radix components (menus, selects, tabs, toasts) follow the language direction.
 * `<html dir>` is set by the i18n setup; the wrapper also carries `dir` for portals rendered inside it.
 */
export function UiProvider({ dir, children }: { dir: 'ltr' | 'rtl'; children: ReactNode }) {
  return (
    <DirectionProvider dir={dir}>
      <div dir={dir} className="contents">
        {children}
      </div>
    </DirectionProvider>
  );
}
